import { render, staticRenderFns } from "./HeroHeading.vue?vue&type=template&id=8fd3ced2&"
import script from "./HeroHeading.vue?vue&type=script&lang=js&"
export * from "./HeroHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports